/**
 * @author michalstolarski
 * @since 2024-1-10
 */

import * as React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Nav } from "./ContentTabs.styled";

interface Props {
  testId?: string;
  className?: string;
  children?: React.ReactNode;
}

const Tabs = (props: Props): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <Nav className={props.className}>{props.children}</Nav>
  </TestWrapper>
);

export { Tabs };
